export const MODULE_REQUEST = "MODULE_REQUEST";
export const MODULE_SUCCESS = "MODULE_SUCCESS";
export const MODULE_FAIL = "MODULE_FAIL";
export const MODULE_RESET = "MODULE_RESET";

export const MODULE_AVERAGE_REQUEST = "MODULE_AVERAGE_REQUEST";
export const MODULE_AVERAGE_SUCCESS = "MODULE_AVERAGE_SUCCESS";
export const MODULE_AVERAGE_FAIL = "MODULE_AVERAGE_FAIL";
export const MODULE_AVERAGE_RESET = "MODULE_AVERAGE_RESET";
